import {Directive, HostBinding, HostListener, Input, OnInit, TemplateRef, ViewContainerRef} from "@angular/core";

@Directive({
	selector: '[cpMailTo]',
})
export class MailToDirective implements OnInit{
	@Input() cpMailTo:string;
	@Input() mode:"mailto"|"tel"|"fax"="mailto";

	@HostBinding("href") href;
	@HostBinding("target") target="_blank";

	constructor() {}

	ngOnInit(){
		this.href=this.mode+":"+this.cpMailTo;
	}

	@HostListener('click', ['$event'])
	public onHostClick($event) {
		window.open(this.href, 'mail');
		$event.preventDefault();
	}
}
